import React, { useEffect } from "react";
import "../Home/home.css";
import { MdOutlineCheckBox } from "react-icons/md";

import { NavLink, useHistory } from "react-router-dom";

function Home() {
  const history = useHistory();

  // useEffect(() => {
  //   window.scrollTo(0, 0)
  // }, []);

  return (
    <>
      <section className="slider_section resp_slider_section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <div className="login_title">
                <h1>Care Management Simplified!</h1>
                <p>
                  Welcome to your new experience of care management. Our
                  powerful, easy-to-use and intuitive care platform enhances the
                  continuum-of-care.{" "}
                </p>
                <NavLink to="/plans" className="btn">
                  Start your experience
                </NavLink>
                {/* <button className="btn" >Start your experience</button> */}
              </div>
            </div>
            <div className="col-md-5 img_box resp_slider_section_img">
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/NewhomeRightsideWebsite.svg`}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="content_section padding_botm resp_padding_botm">
        <div className="container">
          <div
            className="row align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="col-md-3 img_box resp_slider_section_img">
              <img alt="" src={`${process.env.PUBLIC_URL}/images/music.svg`} />
            </div>
            <div className="col-md-8 content_body">
              <h3>
                All-In-One Comprehensive Platform meeting all your care
                management needs
              </h3>
              <ul>
                <li>
                  <MdOutlineCheckBox /> Personalized Care Plans
                </li>
                <li>
                  <MdOutlineCheckBox /> Resource Scheduling
                </li>
                <li>
                  <MdOutlineCheckBox /> Task Management
                </li>
                <li>
                  <MdOutlineCheckBox /> Sales Planning
                </li>
                <li>
                  <MdOutlineCheckBox /> Medication Management
                </li>
                <li>
                  <MdOutlineCheckBox /> and much more...
                </li>
              </ul>
              <p>
                Automated, efficient and yet simple-to-use, empowering you to
                focus more on personalized care delivery and growing your care
                service, rather than spending countless hours on care
                administration.{" "}
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="supporting_section resp_supporting_section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-9 content_body ">
              <h3>One platform supporting multi-channel care</h3>
              <p>
                Our platform is highy modular, scalable and has been designed
                keeping in view the needs of care delivery through various
                channels. The service can be provisioned in Care Facilites
                (nursing homes, residential care homes, retirement homes and
                assisted-living) as well as for At-Home Care. This gives
                unmatched flexibility to care service provides.
              </p>
              <p>
                Multi-channel care enables the providers to offer their clients
                with greater accessibility and flexibility, allowing them to
                receive care in a way that best suits their needs and
                preferences.
              </p>
            </div>
            <div className="col-md-3 img_box resp_img_box">
              <img alt="" src={`${process.env.PUBLIC_URL}/images/care-2.svg`} />
            </div>
          </div>
          <div className="col-md-12 text-center">
            <button
              className="btn"
              onClick={() => {
                history.push("/segments");
              }}
            >
              Explore More
            </button>
          </div>
        </div>
      </section>

      <section className="care_facilities_section resp_care_facilities_section">
        <div className="container">
          <div className="col-md-8 offset-4 title resp_care_facilities_section_title">
            <h3>Delivering tangible benefits across the care ecosystem</h3>
          </div>

          <div className="row facilities_row">
            <div className="col-md-5 img_box_home resp_img_box">
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/homeTwo.svg`}
              />
            </div>
            <div className="col-md-7 content_box">
              <h3>Care Managers</h3>
              <div className="bg_theme"></div>
              <ul>
                <li>Dashboards for care activity oversight.</li>
                <li>Optimization of resource allocation.</li>
                <li>Efficient operations for meeting compliances.</li>
                <li>Ensuring high quality standards of care delivery.</li>
                <li>Securely and easily manage client data. </li>
              </ul>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div className="row facilities_row">
            <div className="col-md-7 content_box">
              <h3>Care Team</h3>
              <div className="bg_theme"></div>
              <ul>
                <li>Readily accessible information reduces response times.</li>
                <li>
                  Personalized care plans improve quality of care delivered.
                </li>
                <li>
                  360 view of the client helps continuity of personalized care.
                </li>
                <li>Ease of managing daily tasks and schedules.</li>
                <li>Convenience in communications and reporting.</li>
              </ul>
            </div>

            <div className="col-md-5 img_box_home text-right resp_img_box">
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/homeOne.svg`}
              />
            </div>

            <div className="col-md-5 img_box_home resp_img_box">
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/careteam.svg`}
              />
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />

          <div
            className="row facilities_row"
            style={{ justifyContent: "space-between" }}
          >
            <div className="col-md-5 img_box_home_Friends&Family resp_img_box">
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/homeThree.svg`}
              />
            </div>
            <div className="col-md-7 content_box">
              <h3>Friends & Family</h3>
              <div className="bg_theme"></div>
              <ul>
                <li>Ease-of-mind on the care delivered to loved one.</li>
                <li>Easily communicate preferences and consent.</li>
                <li>Up-to-date information on task performance.</li>
                <li>Engage Services.</li>
                <li>Ability to quickly provide feedback or escalate.</li>
              </ul>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />

          <div className="row facilities_row padding_botm resp_padding_botm">
            <div className="col-md-7 content_box">
              <h3>Care Providers</h3>
              <div className="bg_theme"></div>
              <ul>
                <li>Management oversight of all care service operations.</li>
                <li>
                  Monitor key performance metrics across the various care
                  delivery channels to excel in regulatory compliance.
                </li>

                <li>
                  Care provider chains can conveniently add more care sites on
                  the same client account.{" "}
                </li>
                <li>
                  Save countless administrative hours with readily available
                  information at the tips of your fingers.{" "}
                </li>
                <li>
                  Showcase your care quality standards and operational
                  efficiencies to grow your business.{" "}
                </li>
              </ul>
            </div>

            <div className="col-md-5 img_box_home text-right resp_img_box">
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/homeFor.svg`}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="featured_mainSec">
        {/* <div>
          <img style={{ width: '100%',height:'580px', objectFit:'cover' }} src="/images/featured-platforms.png" alt="img" />
        </div> */}
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="content-box">
                <h2>We have been featured on</h2>
              </div>
            </div>
            <div className="col-md-6">
              <div className="imgs-main">
                <ul>
                  <li>
                    <div className="img-box">
                      <img src="/images/featured-1.png" alt="yahoo" />
                    </div>

                    <div className="img-box">
                      <img src="/images/featured-2.png" alt="benzinga" />
                    </div>
                  </li>
                  <li>
                    <div className="img-box">
                      <img src="/images/featured-3.png" alt="img" />
                    </div>
                    <div className="img-box">
                      <img src="/images/featured-4.png" alt="img" />
                    </div>
                  </li>
                  <li>
                    <div className="img-box">
                      <img src="/images/featured-5.png" alt="img" />
                    </div>

                    <div className="img-box">
                      <img src="/images/featured-6.png" alt="img" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="trustedPartners">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="box_content">
                <h3>Your Trusted Partner for success</h3>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="partner_box">
                <div className="box_content">
                  <img src={`https://caremagnus-production-images.s3.eu-west-2.amazonaws.com/p-icon.svg`} alt="" />

                  {/* <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.0976 0C22.886 0 20.755 0.570763 19.0307 1.61884C18.5234 1.5573 18.0079 1.5287 17.4981 1.5287C13.4573 1.5287 9.87239 3.41668 8.39048 6.27629C4.09472 7.53783 1.52958 10.9043 2.19181 14.4043C-0.702024 17.1504 -0.732637 21.0494 2.11372 23.8244C1.39151 27.3148 3.8928 30.7085 8.16108 32.0162C8.99492 33.6934 10.5594 35.0251 12.505 35.8699V48.0769C12.505 48.587 12.7683 49.0761 13.237 49.4367C13.7056 49.7974 14.3413 50 15.004 50C15.6454 50.0001 16.2622 49.8105 16.727 49.4704C16.7335 49.4654 16.74 49.4604 16.7465 49.4554L25 44.2308L33.273 49.4704C33.2747 49.4704 33.2763 49.4704 33.2779 49.4704C33.7414 49.8096 34.3563 49.9992 34.996 50C35.6587 50 36.2944 49.7974 36.763 49.4367C37.2317 49.0761 37.495 48.587 37.495 48.0769V35.8624C39.3186 35.0297 40.7913 33.7631 41.6095 32.1852C45.9028 30.9218 48.4704 27.5553 47.8082 24.0572C50.702 21.3111 50.7326 17.4122 47.8863 14.6372C48.6085 11.1468 46.1023 7.75301 41.834 6.44531C40.3846 3.52993 36.7784 1.60006 32.6776 1.60006C32.2078 1.60006 31.7392 1.62701 31.2719 1.67894C29.5301 0.592398 27.3567 0 25.0976 0ZM25.0976 3.84615C26.2646 3.84615 27.4335 4.17088 28.3531 4.81896L29.7881 5.82933L31.6916 5.52509C32.0215 5.47317 32.3527 5.44621 32.6776 5.44621C34.7392 5.44621 36.6233 6.47239 37.2656 8.04162L37.8513 9.4689L39.7011 9.9384C42.0502 10.5346 43.428 12.4001 42.8932 14.2578L42.4734 15.7227L43.7717 16.8382C45.4186 18.2574 45.3971 20.4073 43.7278 21.8111L42.4149 22.9117L42.8151 24.3803C43.3199 26.2437 41.904 28.0947 39.5449 28.6659L37.6853 29.1166L37.0752 30.5401C36.413 32.0843 34.5434 33.0867 32.5067 33.0867C32.1619 33.0867 31.8146 33.0562 31.4622 32.9965L29.5587 32.6735L28.1091 33.6726C27.192 34.3034 26.0469 34.6154 24.9024 34.6154C23.7354 34.6154 22.5665 34.2907 21.6469 33.6426L20.2119 32.6322L18.3084 32.9364C17.9785 32.9884 17.6473 33.0153 17.3224 33.0153C15.2608 33.0153 13.3767 31.9892 12.7344 30.4199L12.1487 28.9926L10.2989 28.5231C7.94984 27.927 6.57204 26.0614 7.10682 24.2037L7.52657 22.7389L6.23315 21.6196C4.58631 20.2004 4.60287 18.0542 6.2722 16.6504L7.58514 15.5461L7.1898 14.0775C6.685 12.2141 8.10091 10.3631 10.46 9.79192L12.3196 9.3412L12.9297 7.91767C13.5919 6.37344 15.4615 5.37109 17.4981 5.37109C17.843 5.37109 18.1952 5.40162 18.5475 5.46124L20.4462 5.78425L21.8958 4.78516C22.8079 4.15823 23.9531 3.84615 25.0976 3.84615ZM25 9.61538C21.6861 9.61538 18.508 10.6284 16.1647 12.4317C13.8215 14.2349 12.505 16.6806 12.505 19.2308C12.505 21.7809 13.8215 24.2266 16.1647 26.0299C18.508 27.8331 21.6861 28.8462 25 28.8462C28.3139 28.8462 31.492 27.8331 33.8353 26.0299C36.1785 24.2266 37.495 21.7809 37.495 19.2308C37.495 16.6806 36.1785 14.2349 33.8353 12.4317C31.492 10.6284 28.3139 9.61538 25 9.61538Z" fill="url(#paint0_radial_3403_290)" />
                    <defs>
                      <radialGradient id="paint0_radial_3403_290" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(44.2927) scale(57.28)">
                        <stop stop-color="#F2994A" />
                        <stop offset="1" stop-color="#D5B81B" />
                      </radialGradient>
                    </defs>
                  </svg> */}
                  <h5>Innovative Cloud Platform</h5>
                </div>
                <p>Cutting-Edge All-in-One Platform to meet all your care and operations needs. Uniquely designed to meet the specific requirements of both care facilities and home-care agencies. </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="partner_box">
                <div className="box_content">
                  <img src={`https://caremagnus-production-images.s3.eu-west-2.amazonaws.com/p-icon1.svg`} alt="" />

                  {/* <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M45.4545 0H4.54545C2.03409 0 0 2.03409 0 4.54545V22.7273H38.6364V18.1818L45.4545 25L38.6364 31.8182V27.2727H0V45.4545C0 47.9659 2.03409 50 4.54545 50H45.4545C47.9659 50 50 47.9659 50 45.4545V4.54545C50 2.03409 47.9659 0 45.4545 0Z" fill="url(#paint0_radial_3403_291)" />
                    <defs>
                      <radialGradient id="paint0_radial_3403_291" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(44.2927) scale(57.28)">
                        <stop stop-color="#F2994A" />
                        <stop offset="1" stop-color="#D5B81B" />
                      </radialGradient>
                    </defs>
                  </svg> */}
                  <h5>Ease of Use & Automation</h5>
                </div>
                <p> Let our powerful cloud platform do the heavy lifting so that you can focus on delivering quality care.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="partner_box">
                <div className="box_content">
                  <img src={`https://caremagnus-production-images.s3.eu-west-2.amazonaws.com/p-icon2.svg`} alt="" />

                  {/* <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.7855 0.289062C8.55698 0.289062 6.47617 2.77375 6.3726 6.72231H9.23254C9.31468 4.91423 10.2661 3.7762 11.7018 3.7762C13.1483 3.7762 14.0735 4.84353 14.0735 6.52066C14.0735 8.23052 13.1212 9.38807 11.7158 9.38807H9.91264V12.6391H11.7472C13.4097 12.6391 14.4223 13.7695 14.4223 15.5902C14.4223 17.368 13.3459 18.5953 11.7995 18.5953C10.212 18.5953 9.15271 17.4833 9.06164 15.718H6.10056C6.23449 19.649 8.46454 22.2251 11.7681 22.2251C15.1413 22.2251 17.5821 19.5761 17.5821 15.9197C17.5821 13.1698 16.3096 11.262 14.2793 10.9472V10.6865C15.9293 10.2106 17.0067 8.32814 17.0067 5.9157C17.0067 2.63195 14.8195 0.289062 11.7855 0.289062ZM25.9597 0.289062C22.1043 0.289062 19.7864 4.48193 19.7864 11.4095C19.7864 14.2702 20.2084 16.6699 21.028 18.4477C22.0423 20.8929 23.7662 22.2225 25.9108 22.2251C29.2215 22.2251 31.5679 19.1445 31.5679 14.8081C31.5679 10.8168 29.5062 7.88305 26.6991 7.88305C24.9758 7.88305 23.6003 8.99523 22.9253 10.962H22.7405C22.6798 6.63819 23.9102 3.87457 25.9387 3.87457C27.0994 3.87457 28.0194 4.74 28.3069 6.11243H31.3726C30.953 2.62974 28.7668 0.289062 25.9597 0.289062ZM39.5095 0.289062C35.8702 0.289062 33.6326 4.30774 33.6326 11.2177C33.6326 18.1428 35.8505 22.2251 39.5095 22.2251C43.1684 22.2251 45.3793 18.1323 45.3793 11.2374C45.3793 4.30978 43.138 0.289062 39.5095 0.289062ZM39.5095 3.85981C41.1987 3.85981 42.2438 6.36008 42.2438 11.2177C42.2438 16.1056 41.2095 18.6667 39.5095 18.6642C37.8184 18.6642 36.7716 16.0905 36.7716 11.2177C36.7716 6.37519 37.8273 3.85981 39.5095 3.85981ZM25.8864 11.2472C27.4346 11.2472 28.5615 12.8106 28.5615 14.936C28.5615 17.0312 27.3955 18.6396 25.8794 18.6396C24.3616 18.6396 23.2009 17.0171 23.2009 14.8917C23.2009 12.8092 24.3382 11.2472 25.8864 11.2472ZM4.23812 25.1072C4.23812 25.1072 0.666687 26.4167 0.666687 32.6619C0.666687 39.597 6.05419 45.2529 20.3095 45.2529V48.6319C20.3095 50.0521 21.4968 50.813 22.2557 49.8762L27.6686 43.1971C28.4061 42.288 28.4061 40.6658 27.6686 39.7542L22.2557 33.075C21.4968 32.1382 20.3095 32.8966 20.3095 34.3194V37.6983C8.11669 37.6983 3.34526 33.6112 3.34526 30.1437C3.34526 28.4917 4.23812 27.6254 4.23812 27.6254V25.1072ZM47.0953 25.1072V27.6254C47.0953 27.6254 47.9881 28.4917 47.9881 30.1437C47.9881 33.6112 43.2167 37.6983 31.0238 37.6983V45.2529C45.2792 45.2529 50.6667 39.597 50.6667 32.6619C50.6667 26.4167 47.0953 25.1072 47.0953 25.1072Z" fill="url(#paint0_radial_3403_292)" />
                    <defs>
                      <radialGradient id="paint0_radial_3403_292" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(0.666687 0.289062) rotate(44.2927) scale(57.28)">
                        <stop stop-color="#F2994A" />
                        <stop offset="1" stop-color="#D5B81B" />
                      </radialGradient>
                    </defs>
                  </svg> */}

                  <h5>Get the Whole Picture</h5>
                </div>
                <p> Gain complete visibility into your operations and person-centered care to optimize decisions and enhance client outcomes.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="partner_box">
                <div className="box_content">
                  <img src={`https://caremagnus-production-images.s3.eu-west-2.amazonaws.com/p-icon3.svg`} alt="" />

                  {/* <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.0013 0L27.4248 4.64079L1.22758 17.6333C0.69195 17.8991 0.28862 18.3575 0.10632 18.9077C-0.0759793 19.4579 -0.0223144 20.0549 0.255509 20.5673C0.533332 21.0796 1.01255 21.4654 1.58776 21.6398C2.16296 21.8142 2.78702 21.7629 3.32265 21.4971L29.4621 8.53006L31.8191 13.0435L38.6369 1.06997L25.0013 0ZM43.1822 15.2174C41.9277 15.2174 40.9095 16.1913 40.9095 17.3913V50H50V17.3913C50 16.1913 48.9819 15.2174 47.7274 15.2174H43.1822ZM29.5465 21.7391C28.292 21.7391 27.2739 22.713 27.2739 23.913V50H36.3643V23.913C36.3643 22.713 35.3462 21.7391 34.0917 21.7391H29.5465ZM15.9108 28.2609C14.6563 28.2609 13.6382 29.2348 13.6382 30.4348V50H22.7286V30.4348C22.7286 29.2348 21.7105 28.2609 20.456 28.2609H15.9108ZM2.27512 34.7826C1.02063 34.7826 0.00250276 35.7565 0.00250276 36.9565V50H9.09296V36.9565C9.09296 35.7565 8.07483 34.7826 6.82034 34.7826H2.27512Z" fill="url(#paint0_radial_3403_293)" />
                    <defs>
                      <radialGradient id="paint0_radial_3403_293" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(44.2927) scale(57.28)">
                        <stop stop-color="#F2994A" />
                        <stop offset="1" stop-color="#D5B81B" />
                      </radialGradient>
                    </defs>
                  </svg> */}
                  <h5>Modular and Scalable</h5>
                </div>
                <p> Our platform scales effortlessly with your business needs, offering flexibility to adapt and grow without constraints.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="partner_box">
                <div className="box_content">
                  <img src={`https://caremagnus-production-images.s3.eu-west-2.amazonaws.com/p-icon4.svg`} alt="" />

                  {/* <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25 0C14.5409 0 3.66211 2.16064 3.66211 2.16064L3.65323 2.16878C2.62382 2.35768 1.69747 2.8674 1.03153 3.61136C0.365584 4.35532 0.00110652 5.28765 0 6.25V18.75C0 40.4125 22.7761 49.467 22.7761 49.467C23.4553 49.8164 24.2211 49.9999 25 50C25.7759 49.9985 26.5384 49.815 27.215 49.467H27.2239C27.2239 49.467 50 40.4125 50 18.75V6.25C50.0005 5.2851 49.6357 4.34995 48.9679 3.60415C48.3 2.85836 47.3704 2.34816 46.3379 2.16064C46.3379 2.16064 35.4591 0 25 0ZM38.6364 12.5C39.2176 12.5 39.7989 12.7031 40.2433 13.1104C41.1319 13.9249 41.1319 15.2417 40.2433 16.0563L23.0602 31.8075C22.6329 32.1991 22.0556 32.4178 21.4533 32.4178C20.851 32.4178 20.2714 32.1991 19.8464 31.8075L11.9984 24.6134C11.1098 23.7989 11.1098 22.4821 11.9984 21.6675C12.887 20.8529 14.3235 20.8529 15.2122 21.6675L21.4533 27.3885L37.0295 13.1104C37.4738 12.7031 38.0551 12.5 38.6364 12.5Z" fill="url(#paint0_radial_3403_294)" />
                    <defs>
                      <radialGradient id="paint0_radial_3403_294" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(44.2927) scale(57.28)">
                        <stop stop-color="#F2994A" />
                        <stop offset="1" stop-color="#D5B81B" />
                      </radialGradient>
                    </defs>
                  </svg> */}
                  <h5>Data Security is Our Priority</h5>
                </div>
                <p> We prioritize your data security with state-of-the-art measures, ensuring your information remains protected at all times</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="partner_box">
                <div className="box_content">
                  <img src={`https://caremagnus-production-images.s3.eu-west-2.amazonaws.com/p-icon5.svg`} alt="" />

                  {/* <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25 0C11.1937 0 0 11.1937 0 25C0 38.8062 11.1937 50 25 50C38.8062 50 50 38.8062 50 25C50 11.1937 38.8062 0 25 0ZM15.7511 15.861C20.047 15.861 23.2461 18.3637 23.6857 22.0866H19.2668C18.8272 20.5366 17.5095 19.5964 15.7511 19.5964C13.2491 19.5964 11.7594 21.6461 11.7594 25.0773C11.7594 28.569 13.4084 30.6925 15.9709 30.6925C18.0104 30.6925 19.4249 29.4974 19.5353 27.714L19.5475 27.417H16.3249V24.3408H23.8688V26.6154C23.8688 31.4612 20.8545 34.4279 15.8732 34.4279C10.4524 34.4279 7.19401 30.9241 7.19401 25.1261C7.19401 19.4011 10.4657 15.861 15.7511 15.861ZM35.0749 15.861C40.3728 15.861 43.7419 19.4133 43.7419 25.1383C43.7439 30.8758 40.3728 34.4279 35.0749 34.4279C29.752 34.4279 26.3835 30.8758 26.3835 25.1383C26.3835 19.4133 29.7894 15.861 35.0749 15.861ZM34.6069 19.8853C32.1298 19.8853 30.481 22.0579 30.481 25.4517C30.481 28.8579 32.1049 31.0303 34.6069 31.0303C37.084 31.0303 38.7207 28.8579 38.7207 25.4517C38.7207 22.0579 37.0736 19.8853 34.6069 19.8853Z" fill="url(#paint0_radial_3403_295)" />
                    <defs>
                      <radialGradient id="paint0_radial_3403_295" cx="0" cy="0" r="1" gradientUnits="userSpceOnUse" gradientTransform="rotate(44.2927) scale(57.28)">
                        <stop stop-color="#F2994A" />
                        <stop offset="1" stop-color="#D5B81B" />
                      </radialGradient>
                    </defs>
                  </svg> */}

                  <h5>Effortless Onboarding</h5>
                </div>
                <p> Our platform enables user-friendly onboarding, ensuring a seamless transition and quick adoption without unnecessary complexities.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="delevring_section">
        <div className="container-fluid">
            <div className="row">
              <div className="col-md-7 title offset-5 p-0">
                 <div className="bg_theme"></div> 
                <h3>Delivering tangible benefits across the care ecosystem</h3>
              </div>
            </div>
        </div>


        
       <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="delevring_box">
                <div className="delevring_box_img">
                    <img alt="" src={`${process.env.PUBLIC_URL}/images/care-n-1.svg`}/>
                </div>
                <div className="delevring_box_body">
                  <h4>Care Managers</h4>
                  <ul>
                    <li>Dashboards for care activity oversight</li>
                    <li>Optimization of resource allocation</li>
                    <li>Efficient operations for meeting compliances</li>
                    <li>Ensuring high quality standards of care delivery</li>
                    <li>Securely and easily manage client data </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="delevring_box">
                <div className="delevring_box_img">
                    <img alt="" src={`${process.env.PUBLIC_URL}/images/care-n-2.svg`}/>
                </div>
                <div className="delevring_box_body">
                  <h4>Care Team</h4>
                  <ul>
                    <li>Readily accessible information reduces response times</li>
                    <li>Personalized care plans improve quality of care delivered</li>
                    <li>360 view of the client helps continuity of personalized care</li>
                    <li>Ease of managing daily tasks and schedules</li>
                    <li>Convenience in communications and reporting</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="delevring_box">
                <div className="delevring_box_img">
                    <img alt="" src={`${process.env.PUBLIC_URL}/images/care-n-3.svg`}/>
                </div>
                <div className="delevring_box_body">
                  <h4>Friends & Family</h4>
                  <ul>
                    <li>Ease-of-mind on the care delivered to loved one</li>
                    <li>Easily communicate preferences and consent</li>
                    <li>Up-to-date information on task performance</li>
                    <li>Add other members to the group</li>
                    <li>Ability to quickly provide feedback or escalate</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> 
      </section>*/}
    </>
  );
}
export default Home;
